import {
  NESTED_TRACKS_IN_SEARCH,
  TRACK_NESTING,
} from '@disco/constants/FeatureTypes'
import { useFeatureEnabled } from '@disco/state-management/selectors/business'
import { getConstanceSetting } from '@disco/state-management/selectors/user'

import { useSelector } from 'hooks/use-redux'

// Two gates: TRACK_NESTING is the account-level feature, NESTED_TRACKS_IN_SEARCH
// hides the expandable rows until the project ships and is removed then.
export const useNestedTracksEnabled = (): boolean => {
  const trackNestingEnabled = useFeatureEnabled(TRACK_NESTING)
  const nestedTracksInSearchEnabled = Boolean(
    useSelector(state => getConstanceSetting(state, NESTED_TRACKS_IN_SEARCH)),
  )

  return trackNestingEnabled && nestedTracksInSearchEnabled
}
